import { createSelector } from 'reselect'
import { AppGlobalState, Progress } from '../../types'
import { DiscountRule } from './types'
import { EntityMetadata } from 'modules/domain/types'

const dict = (state: AppGlobalState) => state.discountRule.items
const ids = (state: AppGlobalState) => state.discountRule.ids
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const item = (state: AppGlobalState, id: string): DiscountRule | undefined => state.discountRule.items[id]
const meta = (state: AppGlobalState, id: string): EntityMetadata<DiscountRule> =>
  state.discountRule.meta[id] || {
    fetchError: null,
    fetchProgress: Progress.IDLE,
    id,
    removeError: null,
    removeProgress: Progress.IDLE,
    updateError: null,
    updateProgress: Progress.IDLE,
  }
const itemFetchProgress = (state: AppGlobalState) => state.discountRule.itemFetchProgress
const listFetchProgress = (state: AppGlobalState) => state.discountRule.listFetchProgress
const listFetchError = (state: AppGlobalState) => state.discountRule.listFetchError
const listFetchErrorDetail = (state: AppGlobalState) => state.discountRule.listFetchErrorDetail
const listFetchNextProgress = (state: AppGlobalState) => state.discountRule.listFetchNextProgress
const listFetchNextError = (state: AppGlobalState) => state.discountRule.listFetchNextError
const listFetchNextErrorDetail = (state: AppGlobalState) => state.discountRule.listFetchNextErrorDetail
const list = createSelector(dict, ids, listFetchProgress, (dict, ids, progress) => {
  if (progress === Progress.WORK) {
    return []
  }
  const result: DiscountRule[] = []
  for (const id of ids) {
    result.push(dict[id])
  }
  return result
})

const filter = (state: AppGlobalState) => state.discountRule.filter
const sorting = (state: AppGlobalState) => state.discountRule.sorting
const page = (state: AppGlobalState) => state.discountRule.page
const total = (state: AppGlobalState) => state.discountRule.total
const updateProgress = (state: AppGlobalState) => state.discountRule.updateProgress
const removeProgress = (state: AppGlobalState) => state.discountRule.removeProgress
const addProgress = (state: AppGlobalState) => state.discountRule.addProgress
const hasNext = (state: AppGlobalState) => state.discountRule.total > state.discountRule.ids.length
const pageSize = (state: AppGlobalState) => state.discountRule.pageSize
const pages = (state: AppGlobalState) => Math.ceil(state.discountRule.total / state.discountRule.pageSize)

const DiscountRuleSelectors = {
  filter,
  sorting,
  page,
  total,
  updateProgress,
  removeProgress,
  addProgress,
  item,
  meta,
  itemFetchProgress,
  listFetchProgress,
  listFetchError,
  listFetchErrorDetail,
  list,
  dict,
  ids,
  hasNext,
  pageSize,
  listFetchNextProgress,
  listFetchNextError,
  listFetchNextErrorDetail,
  pages,
}

export default DiscountRuleSelectors
